export default class Hero
{
  constructor(titles, tabs, image) 
  {
    this.titles = titles; // {} instead of array to support stringify
    this.tabs = tabs;
    this.image = image; 
  }    

  isValid()
  {
    var result = this.tabs && Array.isArray(this.tabs) && this.tabs.length;

    if(result)
    {
      // Titles
      for (const [key, value] of Object.entries(this.titles)) {
        if(!value)
        {
          result = false;
          break;
        };
      }
    }

    return result;
  }
}